import { css } from "lit";

export const postsSelectionGridStyles = css`
  :host {
    display: block;
    width: 100%;
    overflow: auto;
  }

  .posts-selection-container {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .posts-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }
  .post-card-container {
    position: relative;

    post-card {
      width: 120px;
      height: 179px;
    }
  }
  .post-card-container.selected post-card {
    --card-border: 2px solid var(--sds-color-border-success-default);
    --card-background: var(--sds-color-background-success-subtle);
  }

  .checkbox-overlay {
    border-radius: 50%;
    overflow: hidden;
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .post-card-container:hover .checkbox-overlay,
  .post-card-container.selected .checkbox-overlay {
    opacity: 1;
  }

  .checkbox {
    width: 16px;
    height: 16px;

    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
  }

  .checkbox.checked {
    background: rgb(30 30 30 / 0.8);
  }

  .checkmark {
    color: var(--sds-color-icon-positive-default);
  }

  /* Loading States */
  .loading-state {
    width: 100%;
  }

  .loading-grid {
    display: flex;

    gap: 8px;
  }

  .skeleton-card {
    width: 120px;
    height: 179px;
    border-radius: 1.3px;
    background: linear-gradient(
      90deg,
      var(--sds-color-background-default-tertiary) 25%,
      var(--sds-color-background-default-secondary) 50%,
      var(--sds-color-background-default-tertiary) 75%
    );
    background-size: 200% 100%;
    animation: shimmer 2s infinite;
    overflow: hidden;
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  /* Error and Empty States */
  .error-state,
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: var(--sds-size-space-800) var(--sds-size-space-400);
    text-align: center;
  }

  .error-message,
  .empty-message {
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-medium);
    color: var(--sds-color-text-default-primary);
    margin: 0 0 var(--sds-size-space-300) 0;
  }

  .empty-description {
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    color: var(--sds-color-text-default-secondary);
    margin: 0;
  }

  .retry-button {
    margin-top: var(--sds-size-space-400);
    padding: var(--sds-size-space-300) var(--sds-size-space-600);
    border: 1px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-300);
    background: var(--sds-color-background-default-default);
    color: var(--sds-color-text-default-primary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .retry-button:hover {
    background: var(--sds-color-background-default-hover);
    border-color: var(--sds-color-border-default-hover);
  }

  .retry-button:active {
    transform: translateY(1px);
  }
`;
